// src/Utils/axiosInstance.js
import axios from 'axios';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from './ApiEndPoints';


const baseUrl = API_ENDPOINTS.getBaseUrl();
const axiosInstance = axios.create({
  baseURL: baseUrl,
   timeout: 1800000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach token to every request
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration (401 error)
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401 || error.response.status === 403) {
       const navigate = useNavigate();
      localStorage.removeItem("token");
       navigate('/', { replace: true }); // Redirect to login
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
